(() => {
  const root = document.querySelector('.np-header');
  if (!root || root.dataset.npInitialized === 'true') return;
  root.dataset.npInitialized = 'true';

  const menuToggle = root.querySelector('[data-np-menu-toggle]');
  const mobilePanel = root.querySelector('[data-np-mobile-panel]');
  const drawer = root.querySelector('[data-np-cart-drawer]');
  const overlay = root.querySelector('[data-np-cart-overlay]');
  const openButton = root.querySelector('[data-np-cart-open]');
  const closeButton = root.querySelector('[data-np-cart-close]');
  const body = root.querySelector('[data-np-cart-body]');
  const footer = root.querySelector('[data-np-cart-footer]');
  const countNodes = root.querySelectorAll('[data-np-cart-count]');
  const subtotalNode = root.querySelector('[data-np-cart-subtotal]');
  const language = root.querySelector('[data-np-language]');

  const money = (cents, currency = 'EUR') => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
  const escapeHTML = (value) => String(value ?? '').replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));

  const setCartCount = (count) => countNodes.forEach((node) => { node.textContent = count; });

  const openDrawer = async () => {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    openButton?.setAttribute('aria-expanded', 'true');
    overlay.hidden = false;
    document.documentElement.classList.add('np-cart-is-open');
    await refreshCart();
    closeButton?.focus();
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    openButton?.setAttribute('aria-expanded', 'false');
    overlay.hidden = true;
    document.documentElement.classList.remove('np-cart-is-open');
    openButton?.focus();
  };

  const renderEmpty = (cart) => {
    body.innerHTML = '<div class="np-cart-empty"><p>Your cart is empty.</p><a class="np-header__button" href="/collections/all">Discover the collection</a></div>';
    footer.hidden = true;
    setCartCount(cart.item_count);
  };

  const renderCart = (cart) => {
    setCartCount(cart.item_count);
    if (!cart.item_count) return renderEmpty(cart);

    body.innerHTML = cart.items.map((item) => {
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p>${escapeHTML(item.variant_title)}</p>` : '';
      return `<div class="np-cart-item" data-np-line="${escapeHTML(item.key)}">
        <a class="np-cart-item__image" href="${escapeHTML(item.url)}"><img src="${escapeHTML(item.image || '')}" alt="${escapeHTML(item.product_title)}" loading="lazy"></a>
        <div class="np-cart-item__content">
          <a href="${escapeHTML(item.url)}" class="np-cart-item__title">${escapeHTML(item.product_title)}</a>
          ${variant}
          <p>${money(item.final_line_price, cart.currency)}</p>
          <div class="np-cart-item__controls">
            <button type="button" data-np-quantity="decrease" data-np-line="${escapeHTML(item.key)}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-np-quantity="increase" data-np-line="${escapeHTML(item.key)}" aria-label="Increase quantity">+</button>
            <button type="button" data-np-remove="${escapeHTML(item.key)}">Remove</button>
          </div>
        </div>
      </div>`;
    }).join('');

    subtotalNode.textContent = money(cart.total_price, cart.currency);
    footer.hidden = false;
  };

  const refreshCart = async () => {
    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart request failed');
      renderCart(await response.json());
    } catch (error) {
      body.innerHTML = '<p role="alert">We could not load your cart. Please try again.</p>';
    }
  };

  const changeLine = async (key, quantity) => {
    try {
      const response = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      if (!response.ok) throw new Error('Cart update failed');
      renderCart(await response.json());
    } catch (error) {
      await refreshCart();
    }
  };

  menuToggle?.addEventListener('click', () => {
    const expanded = menuToggle.getAttribute('aria-expanded') === 'true';
    menuToggle.setAttribute('aria-expanded', String(!expanded));
    mobilePanel.hidden = expanded;
  });

  language?.addEventListener('change', () => language.form?.submit());
  openButton?.addEventListener('click', openDrawer);
  closeButton?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });

  root.addEventListener('click', (event) => {
    const remove = event.target.closest('[data-np-remove]');
    if (remove) return changeLine(remove.dataset.npRemove, 0);

    const quantity = event.target.closest('[data-np-quantity]');
    if (quantity) {
      const key = quantity.dataset.npLine;
      const line = quantity.closest('.np-cart-item');
      const current = Number(line?.querySelector('span')?.textContent || 1);
      return changeLine(key, quantity.dataset.npQuantity === 'increase' ? current + 1 : Math.max(0, current - 1));
    }
  });
})();
